import { NavLink } from "react-router-dom";
import { useQuote } from "@/context/QuoteContext";
import { useAuth } from "@/context/AuthContext";
import { testIds } from "@/constants/testIds";
import { ShoppingCart, Package, Shield, Briefcase } from "lucide-react";

const linkBase =
  "flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-semibold uppercase tracking-wider transition-all";
const linkActive = "bg-rose-600 text-white shadow-lg shadow-rose-900/40";
const linkIdle = "text-zinc-400 hover:text-white hover:bg-zinc-800/70";

export default function Header() {
  const { totalItems } = useQuote();
  const { isAdmin, isCollab } = useAuth();

  return (
    <header className="sticky top-0 z-50 bg-zinc-950/85 backdrop-blur-md border-b border-zinc-800/80">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <NavLink
          to="/"
          data-testid={testIds.brandLogo}
          className="flex flex-col leading-none select-none"
        >
          <div className="flex items-baseline">
            <span className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tight text-white">
              Spectrum
            </span>
            <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-rose-600 ml-1 mb-1 animate-pulse" />
          </div>
          <span className="hidden sm:block text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mt-0.5">
            We <span className="text-rose-500">Light</span> Up Your Events
          </span>
        </NavLink>

        <nav className="flex items-center gap-1 sm:gap-2">
          <NavLink
            to="/catalogo"
            data-testid={testIds.navCatalog}
            className={({ isActive }) =>
              `${linkBase} ${isActive ? linkActive : linkIdle}`
            }
          >
            <Package size={16} />
            <span className="hidden xs:inline sm:inline">Catalogo</span>
          </NavLink>
          <NavLink
            to="/preventivo"
            data-testid={testIds.navQuote}
            className={({ isActive }) =>
              `${linkBase} ${isActive ? linkActive : linkIdle} relative`
            }
          >
            <ShoppingCart size={16} />
            <span className="hidden xs:inline sm:inline">Preventivo</span>
            {totalItems > 0 && (
              <span
                data-testid={testIds.quoteCounter}
                className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold font-mono flex items-center justify-center border-2 border-zinc-950"
              >
                {totalItems}
              </span>
            )}
          </NavLink>
          <NavLink
            to="/collaboratori"
            data-testid={testIds.navCollab}
            className={({ isActive }) =>
              `${linkBase} ${isActive ? linkActive : linkIdle}`
            }
          >
            <Briefcase size={16} />
            <span className="hidden sm:inline">
              {isCollab ? "Il mio service" : "Partner"}
            </span>
          </NavLink>
          <NavLink
            to="/admin"
            data-testid={testIds.navAdmin}
            className={({ isActive }) =>
              `${linkBase} ${isActive ? linkActive : linkIdle}`
            }
          >
            <Shield size={16} />
            <span className="hidden sm:inline">
              {isAdmin ? "Admin" : "Accesso"}
            </span>
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
